(() => {
  'use strict';
  if (window.__productPerformancePilot) return;
  window.__productPerformancePilot = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-play], [data-pp-close]');
    if (!button) return;
    const wrapper = button.closest('[data-pp-video]');
    if (!wrapper) return;
    const play = wrapper.querySelector('[data-pp-play]');
    const close = wrapper.querySelector('[data-pp-close]');
    if (button.hasAttribute('data-pp-play')) {
      if (wrapper.querySelector(':scope > iframe')) return;
      const original = wrapper.querySelector('template').content.querySelector('iframe');
      if (!original) return;
      const frame = original.cloneNode(true);
      // Preserve the exact original URL; the native player retains its own Play control.
      frame.title = frame.title || play.getAttribute('aria-label');
      frame.setAttribute('allowfullscreen', '');
      wrapper.insertBefore(frame, close);
      play.hidden = true;
      close.hidden = false;
      close.focus();
    } else {
      const frame = wrapper.querySelector(':scope > iframe');
      if (frame) frame.remove();
      play.hidden = false;
      close.hidden = true;
      play.focus();
    }
  });
})();
